export const replaceBuyer = (state, payload) => {
  state.loadedBuyer = payload;
};

export const buyerDisabled = (state, payload) => {
  state.loadedBuyer = { ...state.loadedBuyer, disabled: true };
};

export const buyerEnabled = (state, payload) => {
  state.loadedBuyer = { ...state.loadedBuyer, disabled: false };
};

export const buyerRestored = (state, payload) => {
  const updatedBuyer = { ...state.list[payload], deleted_at: false };
  state.list = { ...state.list, [payload]: updatedBuyer };
};

export const reset = (state, payload) => {
  state.loadedBuyer = {};
};

export const buyerDocDeleted = (state, payload) => {
  const updatedDocuments = state.loadedBuyer.documents.filter((doc) => doc.id != payload.id);

  state.loadedBuyer = { ...state.loadedBuyer, documents: updatedDocuments };
};

export const processDeletedBuyersStage = (state, payload) => {
  state.loadedBuyer.buyer_stage_id = null;
  state.loadedBuyer.stage = null;
};

export const processDeletedBuyersTerms = (state, payload) => {
  state.loadedBuyer.net_terms_id = null;
  state.loadedBuyer.term = null;
};
